import React from "react";
import PropTypes from "prop-types";
import LockBlackIcon from "./lock_black_24dp.svg?react";
import LockWhiteIcon from "./lock_white_24dp.svg?react";

export default function LockIcon(props) {
	return <div>{props.white ? <LockWhiteIcon /> : <LockBlackIcon />}</div>;
}

LockIcon.propTypes = {
	white: PropTypes.bool,
};
